module.exports = __webpack_public_path__ + "static/media/taffFemale.996f7eac.mp3";